export const isPasteTargetAllowed = (event: ClipboardEvent): boolean => {
  const targetElement = event.target as HTMLElement;

  return targetElement === document.body;
};
